var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 19H18.1C18.3387 19 18.5676 18.9052 18.7364 18.7364C18.9052 18.5676 19 18.3387 19 18.1V1.9C19 1.66131 18.9052 1.43239 18.7364 1.2636C18.5676 1.09482 18.3387 1 18.1 1H1.9C1.66131 1 1.43239 1.09482 1.2636 1.2636C1.09482 1.43239 1 1.66131 1 1.9V18.1C1 18.3387 1.09482 18.5676 1.2636 18.7364C1.43239 18.9052 1.66131 19 1.9 19ZM4.0726 17.2L8.2 13.0726L9.3637 14.2363C9.53248 14.405 9.76135 14.4998 10 14.4998C10.2386 14.4998 10.4675 14.405 10.6363 14.2363L14.5 10.3726L17.2 13.0726V17.2H4.0726ZM17.2 2.8V10.5274L15.1363 8.4637C14.9675 8.29498 14.7386 8.20019 14.5 8.20019C14.2614 8.20019 14.0325 8.29498 13.8637 8.4637L10 12.3274L8.8363 11.1637C8.66752 10.995 8.43865 10.9002 8.2 10.9002C7.96135 10.9002 7.73247 10.995 7.5637 11.1637L2.8 15.9274V2.8H17.2Z",
    fill: "#353434",
    stroke: "#F6F6F6",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/img-icon.d977a44a2b104aaa4cef1838fe106369.svg";
export { ForwardRef as ReactComponent };